import React from 'react';
import {
  Box, Container, Grid, Typography,
} from '@mui/material';
import { ImgBox } from 'views/rebranded-module/common/components';
import useAdabtiveMultiSizeImage from 'views/common/hooks/useAdabtiveMultiSizeImage';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import StyledBox from 'views/rebranded-module/information-module/AboutUsViewV2/components/LeadershipSection/LeadershipSection.styles';

const LeadershipSection: React.FC = () => {
  const content = useContent('AboutUsPage');
  const getSizedImage = useAdabtiveMultiSizeImage();

  return (
    <StyledBox>
      <Container maxWidth="xl" className="LSContainer">
        <Grid container spacing={10}>
          <Grid item xl={6} lg={6} md={12} sm={12} className="LSImageColumn">
            <ImgBox
              image={{
                src: getSizedImage(content.leadershipImage),
                alt: content.leadershipImage.alt,
              }}
              imgWidth="100%"
              imgHeight="424px"
              unoptimized
              className="LSLeadershipImage"
            />
          </Grid>
          <Grid item xl={6} lg={6} md={12} sm={12} xs={12} className="LSTextColumn">
            <Box className="LSHeadingContainer">
              <Typography variant="h3" component="h3" className="LSHeadingLine" textTransform="uppercase">
                {content.leadershipHeadingFirst}
              </Typography>
            </Box>
            <Typography variant="body2" component="p" className="LSParagraph">
              {content.leadershipFirstParagraph}
            </Typography>
            <Typography variant="body2" component="p" className="LSQuote">
              {content.leadershipSecondParagraph}
            </Typography>
            <Typography className="LSSignature">
              {content.leadershipSignature}
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </StyledBox>
  );
};

export { LeadershipSection };
